import throttle from "raf-throttle";

export const backgroundEnhancer = function (el) {
    el.style.height = document.body.offsetHeight + "px";

    function updateBackground() {
        let a = window.pageYOffset;
        el.style.backgroundPosition = "0px " + a / 3 + "px";
    }

    const throttled = throttle(updateBackground);

    window.addEventListener("scroll", throttled);
};
